// extracted by mini-css-extract-plugin
module.exports = {"box":"box-30wkVuOM clearfix"};